import '.b4{position:relative;}.ssr-plugin'
import '.n{width:100%;}.ssr-plugin'
import '.go{min-height:200px;}.ssr-plugin'
import '.d{display:flex;}.ssr-plugin'
import '.e{flex-direction:column;}.ssr-plugin'
import '.a8{justify-content:center;}.ssr-plugin'
import '.a5{align-items:flex-start;}.ssr-plugin'
import '.db{padding:2rem;}.ssr-plugin'
import '.dd{background:var(--palette-white);}.ssr-plugin'
import '.a3{overflow:hidden;}.ssr-plugin'
import '.c6{position:absolute;}.ssr-plugin'
import '.io{top:50%;}.ssr-plugin'
import '.ip{right:1rem;}.ssr-plugin'
import '.iq{transform:translateY(-50%);}.ssr-plugin'
import '.ir{width:120px;}.ssr-plugin'
import '.is{height:120px;}.ssr-plugin'
import '.it{z-index:0;}.ssr-plugin'
import '.a7{align-items:center;}.ssr-plugin'
import '.i2{z-index:1;}.ssr-plugin'
import '.ab{gap:0.5rem;}.ssr-plugin'
import '.iu{max-width:calc(100% - 140px);}.ssr-plugin'
import { Style, styled } from 'inlines'
import { Title } from '@app/components/core/typography/Title'
import { Text } from '@app/components/core/typography/Text'
import { Image } from '@app/components/core/image/Image'

export interface StatisticProps {
  number: string
  subtitle: string
  illustration?: string
  style?: Style
}

export const Statistic = ({
  number,
  subtitle,
  illustration,
  style,
}: StatisticProps) => {
  return (
    <styled.div className="b4 n go d e a8 a5 db dd a3"
      data-testid="statistic"
      style={{
        ...style,
      }}
    >
      {/* Background Illustration - Right Aligned */}
      {illustration && (
        <div className="c6 io ip iq ir is it d a7 a8"
        >
          <Image
            src={illustration}
            alt={`${subtitle} illustration`}
            style={{
              width: '100%',
              height: '100%',
              objectFit: 'contain',
            }}
          />
        </div>
      )}

      {/* Content - Left Aligned with higher z-index */}
      <div className="b4 i2 d e a5 ab iu"
      >
        {/* Bold Number */}
        <Title.H1
          style={{
            fontSize: '4rem',
            fontWeight: '700',
            lineHeight: '100%',
            margin: 0,
            color: 'var(--brand-secondary)',
            fontFamily: 'FunnelDisplay',
          }}
        >
          {number}
        </Title.H1>

        {/* Subtitle */}
        <Text.Medium
          style={{
            color: 'var(--brand-secondary)',
            opacity: 0.8,
            margin: 0,
            lineHeight: '140%',
            fontWeight: '400',
          }}
        >
          {subtitle}
        </Text.Medium>
      </div>
    </styled.div>
  )
}
